/**
 * Whether a TinyMCE value carries anything a reader would see.
 *
 * An "empty" rich-text field is rarely an empty string — the editor stores
 * `<p></p>` or `<p>&nbsp;</p>`, both of which pass a plain `.trim()` check and
 * would render as a blank paragraph. Mirrors `isFilledRichText` in the Strapi
 * rules engine, so the front end and CMS validation agree on what "empty" is.
 */
export const hasRichTextContent = (html?: string | null): boolean =>
  Boolean(
    html
      ?.replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim(),
  );
